<div class="w-full h-full flex flex-col gap-4">
    <div class="relative">
        <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
            <lucide-icon [img]="icons.Search"></lucide-icon>
        </div>
        <input 
            type="search" 
            class="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500" 
            [(ngModel)]="searchQuery" 
            (input)="filterAssessCases()"
            placeholder="Search Assessment Case..."  />
    </div>
    <div class="h-full overflow-y-auto">
        <ng-container *ngIf="filteredAssessCases.length > 0; else emptyAssessCases">
            <table class="w-full text-left">
                <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                    <tr>
                        <th scope="col" class="px-4 py-3 py-3 w-14">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                No.
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 min-w-40">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Case No.
                                <lucide-icon
                                    (click)="sortList('case_id')"
                                    [img]="icons.ArrowUpDown" size="18"
                                ></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 min-w-96">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Summary
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-40 min-w-32">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Stage
                                <lucide-icon
                                    (click)="sortList('current_stage')"
                                    [img]="icons.ArrowUpDown" size="18"
                                ></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-44 min-w-32">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Created At
                                <lucide-icon
                                    (click)="sortList('created')"
                                    [img]="icons.ArrowUpDown" size="18"
                                ></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-40 min-w-32">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Created By
                                <lucide-icon
                                    (click)="sortList('created_by_name')"
                                    [img]="icons.ArrowUpDown" size="18"
                                ></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 min-w-24">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Actions
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let case of filteredAssessCases | paginate: { itemsPerPage: itemsPerPage, currentPage: page }; let i=index;" class="bg-white border-b">
                        <th scope="row" class="px-4 py-4">
                            {{ i + 1 + (page - 1) * itemsPerPage }}
                        </th>
                        <th class="px-4 py-4 font-medium text-gray-900 whitespace-nowrap">
                            {{ case.case_id }}
                        </th>
                        <td class="px-4 py-4 whitespace-pre-line">
                            <div *ngIf="case.is_uploaded; else situationSummary" class="flex flex-col gap-0.5">
                                <span class="italic text-nside-gray-200">External case (uploaded files)</span>
                                <span class="text-sm">
                                    Full Team Threat Assessment required:
                                    <span *ngIf="case.full_team_required === 1" class="font-semibold">Yes</span>
                                    <span *ngIf="case.full_team_required === 0" class="font-semibold">No</span>
                                    <span *ngIf="case.full_team_required == null" class="italic text-nside-gray-200">Not answered yet</span>
                                </span>
                            </div>
                            <ng-template #situationSummary>{{ case.detail_of_situation }}</ng-template>
                        </td>
                        <td class="px-4 py-4">{{ this.stageName[case.current_stage] }}</td>
                        <td class="px-4 py-4">{{ case.created | date: 'MM/dd/yyyy - HH:mm' }}</td>
                        <td class="px-4 py-4">{{ case.created_by_name }}</td>
                        <td class="px-4 py-4">
                            <div class="flex items-center justify-start gap-1">
                                <button 
                                    [attr.data-tooltip-target]="'tooltip-' + case.case_id + '-history'"  data-tooltip-placement="bottom"
                                    class="w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:text-white hover:bg-nside-gray-200"
                                    (click)="$event.preventDefault(); handleOpenModal('history', case);"
                                >
                                    <lucide-icon [img]="icons.History" size="20"></lucide-icon>
                                </button>
                                <div [id]="'tooltip-' + case.case_id + '-history'" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                                    History
                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                                <button 
                                    [attr.data-tooltip-target]="'tooltip-' + case.case_id + '-download'"  data-tooltip-placement="bottom"
                                    class="w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:text-white hover:bg-nside-gray-200"
                                    (click)="$event.preventDefault(); handleOpenModal('download', case);"
                                >
                                    <lucide-icon [img]="icons.Download" size="20"></lucide-icon>
                                </button>
                                <div [id]="'tooltip-' + case.case_id + '-download'" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                                    Download Files
                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                                <button 
                                    [attr.data-tooltip-target]="'tooltip-' + case.case_id + '-threat-assessment-team'"  data-tooltip-placement="bottom"
                                    class="w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:text-white hover:bg-nside-gray-200"
                                    (click)="$event.preventDefault(); handleOpenModal('threat-assessment-team', case);"
                                >
                                    <lucide-icon [img]="icons.FileUser" size="20"></lucide-icon>
                                </button>
                                <div [id]="'tooltip-' + case.case_id + '-threat-assessment-team'" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                                    Threat Assessment Team
                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
        <ng-template #emptyAssessCases>
            <div *ngIf="!loadingCases" class="w-full text-nside-gray-100 italic">
                Empty Assessment Cases
            </div>
        </ng-template>
    </div>
    <div class="flex justify-between items-center">
        <p>{{ filteredAssessCases.length }} in total</p>
        <pagination-controls
            *ngIf="filteredAssessCases.length > this.itemsPerPage" 
            (pageChange)="page = $event"
            previousLabel="Prev"
            nextLabel="Next"
            class="mt-2"
        ></pagination-controls>
    </div>
</div>

<history
    *ngIf="this.showHistory && this.currentCase"
    [caseId]="this.currentCase.case_id"
    (onClose)="handleCloseModal('history')"
></history>

<download-docs
    *ngIf="this.showDownload && this.currentCase"
    [case]="this.currentCase"
    (onClose)="handleCloseModal('download')"
></download-docs>

<case-assess-team-info
    *ngIf="this.showCaseThreatAssessmentTeam && this.currentCase"
    [caseId]="this.currentCase.case_id"
    (onClose)="handleCloseModal('threat-assessment-team')"
></case-assess-team-info>

<div *ngIf="loadingCases || loadingUser">
    <spinner></spinner>
</div>

<popup-message 
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>

<usersnap *ngIf="showUsersnapWidget"></usersnap>